// //cambio: renderer para el template Hub Educativo (page-pilar.php / data-router-view="educativo")
// Extiende Base para heredar Lenis smooth-scroll y el header handler. Sin componentes extra.
import Base from './Base'

export default class extends Base {}
